"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PromoRegularVolumeOutput_1 = require("../model/PromoRegularVolumeOutput");

var PromoRegularVolumeOutputConverter_1 = require("./PromoRegularVolumeOutputConverter");
/**
 * Implementation of {@link PromoRegularVolumeOutputConverter}.
 *
 * @author ZSr
 */


var PromoRegularVolumeOutputConverterImpl =
/*#__PURE__*/
function (_PromoRegularVolumeOu) {
  _inherits(PromoRegularVolumeOutputConverterImpl, _PromoRegularVolumeOu);

  function PromoRegularVolumeOutputConverterImpl() {
    _classCallCheck(this, PromoRegularVolumeOutputConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoRegularVolumeOutputConverterImpl).apply(this, arguments));
  }

  _createClass(PromoRegularVolumeOutputConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PromoRegularVolumeOutput_1.PromoRegularVolumeOutput(PromoRegularVolumeOutput_1.PromoRegularVolumeOutput.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), PromoRegularVolumeOutput_1.PromoRegularVolumeOutput.schema.regularVolume.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        regularVolume: source.regularVolume
      });
      return result;
    }
  }]);

  return PromoRegularVolumeOutputConverterImpl;
}(PromoRegularVolumeOutputConverter_1.PromoRegularVolumeOutputConverter);

exports.PromoRegularVolumeOutputConverterImpl = PromoRegularVolumeOutputConverterImpl;